import { useParams } from 'react-router'

export const useHarvestSaleLotsPageParams = () => useParams<{ cultureId: string }>()
